const initialState = null;

export default function shoppingCartToken(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // GET SYSTEMS
    case 'SHOPPING_CART_SET_TOKEN':
      return payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/shopping-cart-token.js